module.exports = __webpack_public_path__ + "img/parish.4d8dd0dc.jpeg";